import React from 'react';
import { useNavigate } from 'react-router-dom';

import styles from '../Styles/NotFound.module.css';

const SystemFailed = () => {
  const navigate = useNavigate();
  return (
    <div className='liningOverOnPage'>
      <div className='liningPanelOnPage'>
        <svg className={styles.imageTr} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="exclamation-triangle"><path fill="#bfbfbf" d="M12,16a1,1,0,1,0,1,1A1,1,0,0,0,12,16Zm10.67,1.47-8.05-14a3,3,0,0,0-5.24,0l-8,14A3,3,0,0,0,3.94,22H20.06a3,3,0,0,0,2.61-4.53Zm-1.73,2a1,1,0,0,1-.88.51H3.94a1,1,0,0,1-.88-.51,1,1,0,0,1,0-1l8-14a1,1,0,0,1,1.78,0l8.05,14A1,1,0,0,1,20.94,19.49ZM12,8a1,1,0,0,0-1,1v4a1,1,0,0,0,2,0V9A1,1,0,0,0,12,8Z"></path></svg>
        <h1 className={styles.headline}>Онлайн-бронирование в данный момент недоступно</h1>
        <a className={styles.textUnderH}>Для бронирования свяжитесь по телефону:</a>
        <a className={styles.textUnderH} href="">+7 964 837 64 94</a>
        <button type='button' className='button' onClick={() => {navigate('/')}}>Вернуться на главную</button>
      </div>
    </div>
  )
}

export default SystemFailed;